import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HowItWorksSection() {
  const { t } = useTranslation();

  return (
    <section className="how-it-works-section row">
      <div className="absolute-div p-4">
        <h6 className="size-6 lh-32 text-bold">01.</h6>
        <h6 className="size-7 lh-24 text-bold natural-4">
          {t("showing_delivery")}
        </h6>
      </div>
      <div className="col-md-6">
        <div className="left-content">
          <h2 className="size-2 text-bold ls-0 mb-3 ws-pw">
            {t("how_it_works")}
          </h2>
          <h6 className="size-8 natural-4 text-medium lh-24 ws-pw">
            {t("follow_four_steps")}
          </h6>
        </div>
      </div>
      <div className="col-md-6">
        <div className="right-content text-center">
          <img src="/images/dron.png" alt="dron" />
          <h4 className="size-4 natural-8 text-bold">{t("register")}</h4>
          <h6 className="size-7 lh-24 text-medium ws-pw natural-6">
            {t("register_on_the_site")}
          </h6>
          <Link to="login" className="size-8 lh-24 text-bold natural-8">
            {t("get_personal_address")}
          </Link>
        </div>
      </div>
    </section>
  );
}
